<template>
  <div class="panel panel-default">
    <facebook-logout-modal ref="modal" channel="Instagram" :credentials="credentials"></facebook-logout-modal>
    <div class="panel-heading">
      <span style="font-weight: 700" class="text-uppercase">INSTAGRAM</span>
      <a v-if="credentials.facebook_token"><i class="fa fa-cog" aria-hidden="true" @click="openModal"
                                              content="Zugangsdaten bearbeiten" v-tippy></i></a>
      <a class="fa fa-question-circle" v-tippy
         content="Muss mit ihrem Facebook Account verbunden sein. Der Inhalt wird als Beitrag veröffentlicht."></a>
      <div style="float:right">
        <span class="dot-red"
              v-if="!channels[index].foreign_id || (channels[index].publish_later && !isPast(channels[index].publish_at))"
              content="Entwurf" v-tippy></span>
        <span class="dot-green" v-else content="Ausgesendet" v-tippy></span>
      </div>
    </div>
    <div class="panel-body">
      <div
          v-if="isAuth()">
        <vue-toastr ref="toast"></vue-toastr>
        <label for="">Vorschaubild</label>
        <a class="fa fa-question-circle" v-tippy
           content="Die optimale Bildgröße liegt bei 1080 x 1080 Pixel. Die Datei darf 150 KB nicht überschreiten."></a>
        <content-preview minRatio="0.8"
                         maxRatio="1.91"
                         :index="index" :content-prop="{url: channels[index].content_url, type: 'content'}"
                         :disabled="channels[index].foreign_id" @update:channels="channelsUpdated"></content-preview>
        <br>
        <div class="ckeditor-wrapper">
          <label>Content</label>
          <ckeditor v-model="channels[index].news_content" :config="editorConfig"
                    :disabled="!!channels[index].foreign_id"></ckeditor>
        </div>
        <div style="display: flex">
          <div style="font-size: 24px;margin-top: 10px;padding: 0 5px;">@</div>
          <multiselect v-model="channels[index].tagged_users" :multiple="true" :options="options" :taggable="true"
                       @tag="addTag"
                       placeholder="Markierungen setzen" noOptions="Liste ist leer" tagPlaceholder="Hinzufügen"
                       deselectLabel="Entfernen"
                       selectLabel="Hinzufügen"
                       :searchable="!channels[index].foreign_id && !isVideo(channels[index].content_url)">
            <template #noOptions>&nbsp;</template>
          </multiselect>
          <a class="fa fa-question-circle" v-tippy
             style="padding-top: 20px;padding-left: 10px;font-size: 18px"
             content="Wichtige Info: Bitte geben Sie für die zu markierenden Seiten einfach nur den korrekten
                Instagram Namen ein und KEIN @ Zeichen. Die Markierung wird dann automatisch gesetzt. Es können nur Seiten mit öffentlichem Profil markiert werden."></a>
        </div>
        <br>
        <div class="form-group">
          <input type="checkbox" :id="`publish_later${channels[index].id}`" v-model="channels[index].publish_later"
                 :disabled="!!channels[index].foreign_id">
          <label :for="`publish_later${channels[index].id}`">Später veröffentlichen</label>
        </div>
        <div v-if="channels[index].publish_later" style="padding-bottom: 5px;">
          <label for="publish_at">Veröffentlichungsdatum</label>
          <input type="datetime-local" v-model="channels[index].publish_at" id="publish_at" class="form-control"
                 :disabled="channels[index].foreign_id">
        </div>
        <div class="alert alert-warning" style="margin-top: 20px" v-if="channels[index].foreign_id">
          <i class="fa fa-warning"></i> Dieser Post wurde bereits geteilt. Änderungen am Post oder das Löschen des Posts
          sind nicht möglich.
        </div>
      </div>
      <div>
        <div v-if="!isAuth()">
          <facebook-login :index="index"></facebook-login>
        </div>
        <button class="btn btn-sm btn-default" style="float:right" @click="deleteChannel"
                content="Aussendungskanal löschen" v-tippy v-if="!channels[index].foreign_id">
          <i class="fa fa-trash-o" style="color: red"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import VueToastr from 'vue-toastr';
import {mapGetters, mapMutations} from 'vuex';
import Multiselect from 'vue-multiselect';
import FacebookLogin from '../facebook/FacebookLogin';
import ContentPreview from '../image/ContentPreview';
import FacebookLogoutModal from "../modal/FacebookLogoutModal";
import {isPast} from "../../services/checkIfPast";

export default {
  name: 'Instagram',
  components: {FacebookLogoutModal, ContentPreview, FacebookLogin, VueToastr, Multiselect},
  props: ['context', 'index', 'newsHub'],
  data() {
    return {
      options: [],
      tagged_users: [],
      sendNotify: false,
      notifyCustomers: false,
      editorConfig: {
        versionCheck: false,
        toolbar: [
          [
            'Undo',
            'Redo'
          ]
        ],
      },
    };
  },
  methods: {
    isPast,
    channelsUpdated() {
      this.$forceUpdate();
    },
    isAuth() {
      return this.credentials.facebook_token && this.credentials.instagram_business_account_id && (this.credentials.facebook_token_expire_date * 1000 > Date.now());
    },
    isVideo(url) {
      if (url)
        return (url.includes('.mov') || url.includes('.mp4'))
    },
    openModal() {
      let element = this.$refs.modal.$el
      $(element).modal('show')
    },
    addTag(tag) {
      this.options.push(tag);
      this.channels[this.index].tagged_users.push(tag);
    },
    ...mapMutations(['getChannels', 'removeChannel', 'getChannelCredentials']),
    deleteChannel() {
      if (this.removeChannel({id: this.context.id, index: this.index})) {
        this.$refs.toast.s('Aussendungskanal gelöscht');
      }
    },
  },
  computed: {
    ...mapGetters({channels: 'getChannels', record: 'getRecord', credentials: 'getChannelCredentials'}),
  },
  mounted() {
    this.notifyCustomers = !!this.channels[this.index].notify_via;
  },
};
</script>

<style scoped>
</style>
<style>
.ckeditor-wrapper-app .ck-content {
  min-height: 100px;
}
</style>
